import { api } from './api';

export type PastDueCategory = 'earlyStage' | 'lateStage' | 'paymentPlan' | 'bankruptcy';

export type DaysPastDueBucket = 'days6To30' | 'days31To60' | 'days61To90' | 'days91To120';

export interface PastDueAccount {
  category: PastDueCategory;
  daysPastDueBucket?: DaysPastDueBucket;
  finCoAccountId: string;
  concordAccountId: string;
}

export interface PastDueAccountsResponse {
  snapshotTimestamp: string | null;
  accounts: PastDueAccount[];
}

export const pastDueAccountsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPastDueAccounts: build.query<PastDueAccountsResponse, void>({
      query: () => ({
        url: '/admin/past-due-accounts',
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetPastDueAccountsQuery } = pastDueAccountsApi;
